import { useEffect } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

const APP_EVENT_EMITTER_KEY = 'APP_EVENT_EMITTER';

const useAppEventEmitter = () => {
	const eventEmitter = useDriftStore((s) => s.appEventEmitter);

	useEffect(() => {
		window[APP_EVENT_EMITTER_KEY] = eventEmitter;
	}, [eventEmitter]);

	return eventEmitter;
};

export default useAppEventEmitter;
